<template>
<div>
<v-dialog
    v-model="confirm"
    max-width="290">
    <v-card>  
        <v-card-title class="headline">
            {{ Notify.data.confirm.title }}
        </v-card-title>

        <v-card-text>
            {{ Notify.data.confirm.text }}
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                color="green darken-1"
                text
                @click="
                    confirm = false; 
                    Notify.data.confirm.reject();">
                Cancel
            </v-btn>

            <v-btn
                color="green darken-1"
                text
                @click="
                    confirm = false;
                    Notify.data.confirm.resolve();" >
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

<v-dialog v-model="prompt" persistent max-width="600px">
    <v-card>
        <v-card-title>
            <span class="headline">{{ Notify.data.prompt.title }}</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row dense>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field autofocus
                            v-model="promptInput"
                            label="Enter data"
                            :hint="Notify.data.prompt.text"
                            :max-length="Notify.data.prompt.maxLength"
                            :counter="Notify.data.prompt.maxLength"
                            @keydown.enter="resolvePrompt" 
                            autocomplete="off"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text 
                @click="
                    prompt = false; 
                    Notify.data.prompt.reject();">
                    Cancel
            </v-btn>
            <v-btn color="blue darken-1" text 
                @click="resolvePrompt">
                    Submit
            </v-btn>
        </v-card-actions>
    </v-card>
</v-dialog>

</div>
</template>

<script>
import Notify from '../../services/notify'

export default {
    data() {
        return {
            Notify,
            confirm: false,
            prompt: false,
            promptInput: '',
        }
    },
    watch: {
        'Notify.data.confirm': function() {
            this.confirm = true;
        },
        'Notify.data.prompt': function() {
            this.prompt = true;
            this.promptInput = Notify.data.prompt.value;
        }
    },
    methods: {
        resolvePrompt() {
            if(this.promptInput && this.promptInput.length > Notify.data.prompt.maxLength) {
                Notify.error.characterOverflow();
            } else if( this.promptInput && this.promptInput.length > 0 ) {
                this.prompt = false; 
                Notify.data.prompt.resolve(this.promptInput);
            }
        }
    }
}
</script>